<template>
  <div class="not-found-big">
    <div class="pad-50 flex-col flex-center">
      <img class="illustration" src="@/assets/not_found.svg" alt />
      <p class="message">{{ message || "Oops! Nothings in here." }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: String,
  },
};
</script>

<style lang="scss" scoped>
.not-found-big {
  display: block;

  .illustration {
    width: 400px;
    height: auto;
    margin: 20px 0;
  }

  .message {
    margin: 0;
  }
}
</style>
